import React from 'react';

// Material UI
import TableRow from "@mui/material/TableRow";
import {styled} from "@mui/material/styles";

// Assets
import {black500, greyishBlue100, greyishBlue50, greyishBlue500} from "assets/jss/main";

const StyledTableRowHead = styled(TableRow,{
    shouldForwardProp: (prop) => !['isDesktop'].includes(prop), // Empêche la transmission de ces props` au DOM
})(({ theme, isDesktop }) => ({
    'th:first-of-type': {
        borderTop: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        borderBottom: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        borderRadius: isDesktop ? '8px 0 0 8px' : '0',
        paddingTop: isDesktop ? '8px' : '12px',
        paddingBottom: isDesktop ? '8px' : '12px',
        paddingLeft: isDesktop ? '12px': '16px',
    },
    'th:last-child': {
        borderTop: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        borderBottom: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        borderRadius: isDesktop ? '0 8px 8px 0' : '0',
        paddingTop: isDesktop ? '8px' : '12px',
        paddingBottom: isDesktop ? '8px' : '12px',
        paddingRight: isDesktop ? '12px': '16px',
    },
    'th': {
        borderTop: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        borderBottom: isDesktop ? 'unset' : `1px solid ${greyishBlue100}`,
        background: isDesktop ? greyishBlue50 : '#FFF',
        paddingTop: isDesktop ? '8px' : '12px',
        paddingBottom: isDesktop ? '8px' : '12px',
        color: isDesktop ? greyishBlue500 : black500,
        fontWeight: isDesktop ? 400 : 600,
    }
}));


function TableRowHead({isDesktop = false, ...props}) {
    return (
        <StyledTableRowHead {...props} isDesktop={isDesktop}>
            {props.children}
        </StyledTableRowHead>
    );
}

export default TableRowHead;
